import EmployeesPage from './EmployeesPage'

export default EmployeesPage
